// @flow

import React from 'react';
export function CircleLoadingIcon() {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle
        cx="9"
        cy="9"
        r="8"
        fill="white"
        stroke="#8C9196"
        strokeWidth="2"
        strokeDasharray="4 4"
      />
    </svg>
  );
}
